import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DynamicItemCard from 'Components/ComponentLibrary/Molecules/DynamicItemCard';
import AddItemLine from 'Components/ComponentLibrary/Molecules/AddItemLine';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { getBorderRadius } from 'Components/utils';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
  card: {
    margin: theme.spacing(1, 0),
  },
});

const DynamicCardList = ({
  className, classes, name, items, onAdd, onClickItem, refetchItems,
}) => {
  const count = items.length;
  return (
    <Paper
      className={classNames(className, classes.root)}
      variant={'outlined'}
    >
      <AddItemLine count={count} label={name} onAdd={onAdd} />
      <List disablePadding>
        {items.map(resource => {
          let onRemove;
          let errorText;
          if (resource.meta().action('DELETE')) {
            onRemove = async (event) => {
              event.stopPropagation(); // Stop onClick event for onCardClick
              try {
                await resource.link('self').delete();
                refetchItems();
              } catch (e) {
                errorText = 'Delete Item Failed!';
              }
            };
          }
          return (
            <DynamicItemCard
              key={resource.id()}
              name={resource.attr('label')}
              description={resource.attr('subLabel')}
              onRemove={onRemove}
              subtext={errorText || (!onRemove && 'One is Required')}
              className={classes.card}
              onCardClick={() => {
                resource.withRelationship(fr.relationships.item.name, async (rel) => {
                  try {
                    const next = await rel.link('related').get();
                    onClickItem(next);
                  } catch (e) {
                    errorText = 'Failed to Edit Item!';
                  }
                },
                () => null);
              }}
              color={resource.attr('isComplete') === 'true' ? 'accentBlue20' : 'lightGray5'}
            />
          );
        })}
      </List>
    </Paper>
  );
};

DynamicCardList.defaultProps = {
  items: [],
  className: null,
  onClickItem: null,
};

DynamicCardList.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array,
  onAdd: PropTypes.func.isRequired,
  refetchItems: PropTypes.func.isRequired,
  classes: PropTypes.array.isRequired,
  onClickItem: PropTypes.func,
  className: PropTypes.string,
};

export default withStyles(styles)(DynamicCardList);
